<mat-card class="card">
  <mat-card-header>
    <h3 mat-card-title>{{ 'Notes' | translate }}</h3>
  </mat-card-header>
  <mat-card-content>
    <ix-app-section-expand-collapse class="notes">
      <div class="notes-list">
        <markdown [data]="app.info.notes"></markdown>
      </div>
    </ix-app-section-expand-collapse>
  </mat-card-content>
</mat-card>
